import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  createGroupStart,
  deleteGroupStart,
  editGroupStart,
} from "../../redux/exam-group/reducer";

const useExamGroupEditor = () => {
  const dispatch = useDispatch();

  const createGroup = useCallback(
    (data) => {
      dispatch(createGroupStart(data));
    },
    [dispatch]
  );

  const editGroup = useCallback(
    (data) => {
      dispatch(editGroupStart(data));
    },
    [dispatch]
  );

  const deleteGroup = useCallback(
    (data) => {
      dispatch(deleteGroupStart(data));
    },
    [dispatch]
  );
  return { createGroup, editGroup, deleteGroup };
};

export default useExamGroupEditor;
